import { render, staticRenderFns } from "./saleothersubject.vue?vue&type=template&id=eeba0bd8&scoped=true&"
import script from "./saleothersubject.vue?vue&type=script&lang=js&"
export * from "./saleothersubject.vue?vue&type=script&lang=js&"
import style0 from "./saleothersubject.vue?vue&type=style&index=0&id=eeba0bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeba0bd8",
  null
  
)

export default component.exports